// Inline CSS transform helper for @dnd-kit (replaces @dnd-kit/utilities which is not installed)
export interface DndTransform {
  x: number;
  y: number;
  scaleX: number;
  scaleY: number;
}

export const DndCSS = {
  Transform: {
    toString(transform: DndTransform | null): string | undefined {
      if (!transform) return undefined;
      const { x, y, scaleX, scaleY } = transform;
      return `translate3d(${x}px, ${y}px, 0) scaleX(${scaleX}) scaleY(${scaleY})`;
    },
  },
};
